module.exports = __webpack_public_path__ + "static/media/hr.84e95a3b.svg";